import React, { useState, useEffect } from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";
import UserForm from "../Forms/UserForm";

export default function EditUserModal() {
  const {
    isActive,
    deactivateTool,
    adminModalUser,
    updateUser,
    isAdminModalLoading,
    setIsAdminModalLoading,
  } = useStore();
  const [successAlertShown, setSuccessAlertShown] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  const [user, setUser] = useState({
    UserName: "",
    FirstName: "",
    LastName: "",
    Title: "",
    Agency: "",
    PhoneNumber: "",
    Email: "",
    Active: false,
    Roles: [],
  });
  const resetUser = () => {
    setUser({
      UserName: adminModalUser?.UserName || "",
      FirstName: adminModalUser?.FirstName || "",
      LastName: adminModalUser?.LastName || "",
      Title: adminModalUser?.Title || "",
      Agency: adminModalUser?.Agency || "",
      PhoneNumber: adminModalUser?.PhoneNumber || "",
      Email: adminModalUser?.Email || "",
      Active: adminModalUser?.Active || false,
      Roles: adminModalUser?.Roles || [],
    });
  };
  useEffect(() => {
    resetUser();
  }, [adminModalUser]);

  const onClose = () => {
    resetUser();
    deactivateTool(ModalKeys.EDIT_USER);
  };

  const onEditUserClicked = () => {
    setIsAdminModalLoading(true);
    updateUser(user);
    setIsAdminModalLoading(false);
    deactivateTool(ModalKeys.EDIT_USER);
    setSuccessAlertShown(true);
    setTimeout(() => {
      setSuccessAlertShown(false);
    }, 5000);
  };

  const buttonClass =
    "btn btn-secondary btn-sm mr-1" +
    (isAdminModalLoading === true ? " opacity-50 cursor-not-allowed" : "");

  return (
    <>
      <BaseModal active={isActive(ModalKeys.EDIT_USER)} title="Edit User">
        <div className="p-3 font-helvetica text-sm">
          <UserForm
            user={user}
            setIsValid={setIsFormValid}
            setUser={setUser}
            isLoading={isAdminModalLoading}
          />
        </div>
        <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
          <button
            disabled={isAdminModalLoading || !isFormValid}
            onClick={onEditUserClicked}
            className={
              buttonClass +
              (!isFormValid ? " opacity-50 cursor-not-allowed" : "")
            }
          >
            Update User
          </button>
          <button
            disabled={isAdminModalLoading}
            onClick={resetUser}
            className={buttonClass}
          >
            Reset
          </button>
          <button
            disabled={isAdminModalLoading}
            onClick={onClose}
            className={buttonClass}
          >
            Cancel
          </button>
        </div>
      </BaseModal>
      {successAlertShown && (
        <div className="absolute top-0 w-full text-center transition-all">
          <div role="alert" className="alert alert-success w-96 m-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>{user.UserName} has been updated.</span>
          </div>
        </div>
      )}
    </>
  );
}
